export enum CoverageNetworkTypeEnum {
    InNetwork = 'InNetwork',
    OutOfNetwork = 'OutOfNetwork'
}
